module.exports = __webpack_public_path__ + "media/images/icons/v2/home-02-bbe84871c344a239a5891b082ab3e8a4.svg";